import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { partnerManagementAdminAccessControl } from '../access-control/partnerManagementAdminAccess.configuration'

const PartnerManagementListPage = lazy(() => import('../pages/list/PartnerManagementListPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const partnerManagementAdminRouter = (
  <DomainRoute
    route="app-admin-partner-management"
    accessControl={partnerManagementAdminAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-partner-management-list"
        component={PartnerManagementListPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
